import { render, staticRenderFns } from "./selectStaff.vue?vue&type=template&id=1d4fd2ff&scoped=true"
import script from "./selectStaff.vue?vue&type=script&lang=js"
export * from "./selectStaff.vue?vue&type=script&lang=js"
import style0 from "./selectStaff.vue?vue&type=style&index=0&id=1d4fd2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4fd2ff",
  null
  
)

export default component.exports